import { useEffect, useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const SLOW_AUTH_MS = 6000;

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const [slow, setSlow] = useState(false);

  // If the /auth/me check hangs more than 6s, surface a visible escape hatch
  // so users never sit on what looks like a dead/black page.
  useEffect(() => {
    if (!loading) {
      setSlow(false);
      return;
    }
    const t = setTimeout(() => setSlow(true), SLOW_AUTH_MS);
    return () => clearTimeout(t);
  }, [loading]);

  if (loading) {
    return (
      <div
        className="min-h-[80vh] flex items-center justify-center px-6"
        data-testid="protected-route-loader"
      >
        <div className="text-center max-w-md">
          <div className="inline-flex items-center gap-2 text-white/60 font-mono text-xs uppercase tracking-[0.3em]">
            <span className="inline-block w-2 h-2 bg-[#E5FE40] animate-pulse" />
            Authenticating
            <span className="cursor-blink" />
          </div>
          {slow && (
            <div className="mt-8 border border-[#FF3333]/40 bg-[#FF3333]/5 p-5 text-left" data-testid="protected-route-slow">
              <div className="text-[10px] uppercase tracking-[0.25em] text-[#FF3333] font-mono mb-2">
                TAKING LONGER THAN USUAL
              </div>
              <p className="text-sm text-white/75 leading-relaxed">
                Auth check is slow. Try a hard refresh (Cmd/Ctrl + Shift + R), or
                head back to the home page and sign in again.
              </p>
              <div className="mt-4 flex gap-3 flex-wrap">
                <button
                  type="button"
                  onClick={() => window.location.reload()}
                  className="btn-primary !py-2 !px-4 text-xs"
                  data-testid="protected-route-slow-refresh"
                >
                  Refresh
                </button>
                <Link
                  to="/"
                  className="btn-secondary !py-2 !px-4 text-xs"
                  data-testid="protected-route-slow-home"
                >
                  Go home
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}
